import { Sites } from "data/utils/globals";
import useGetItem from "./hooks/useGetItem";
import { useUpdate } from "./hooks/useUpdate";
import { SchemaData } from "./hooks/types";
import { UpdateGql } from "./queries/update";
import { GenericMethods } from "../GenericMethods";

function Update({
  slug,
  redirectOnSave,
  updatePermission,
}: {
  slug: string;
  redirectOnSave: string;
  updatePermission: string;
}) {
  if (!slug) return null;

  return (
    <GenericMethods.Update<SchemaData, UpdateGql>
      siteId={Sites.UNIFTEC.id}
      sitePath={Sites.UNIFTEC.path}
      redirectPath={redirectOnSave}
      hideDeleteButton
      useGetItem={useGetItem}
      useUpdate={useUpdate}
      queryParam={slug}
      updatePermission={updatePermission}
    />
  );
}

export default Update;
